import { IMessageHandler } from "./message-handler";
import { IHandlerContext } from "./handler-context";
import { RegisterHandler } from "./handlers/register-handler";
import { LoginHandler } from "./handlers/login-handler";
import { ListUsersHandler } from "./handlers/list-users-handler";
import { SavePortfolioHandler } from "./handlers/save-portfolio-handler";
import { GetPortfolioHandler } from "./handlers/get-portfolio-handler";
import { ExportUserHandler } from "./handlers/export-user-handler";
import { DeleteUserHandler } from "./handlers/delete-user-handler";

export class HandlerFactory {
  static createHandlers(context: IHandlerContext): IMessageHandler<any>[] {
    return [
      new RegisterHandler(context),
      new LoginHandler(context),
      new ListUsersHandler(context),
      new SavePortfolioHandler(context),
      new GetPortfolioHandler(context),
      new ExportUserHandler(context),
      new DeleteUserHandler(context),
    ];
  }
}
